export const FACET_ORDER = ['format', 'style', 'color', 'photo', 'foil', 'price', 'orientation'] as const;
